module.exports = __webpack_public_path__ + "static/sport/banner8.59454b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner8.png
// module id = PgWR
// module chunks = 0